import {createSelector} from "@reduxjs/toolkit";

export function selectConnected() {
  return createSelector(s => s?.userInterface?.connected);
}
